<nz-card >
<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div nz-row >
      <div nz-col nzSpan="3">
        <button nz-button nzType="primary" class="default-button" (click)="OnAdd()">
          <span nz-icon nzType="plus" nzTheme="outline"></span>
          {{ "Add" | translate }}
        </button>
      </div>
    </div>

    <div style="width: 100%;">
      <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
        [nzScroll]="{ y: '500px', x: '1400px' }" nzTitle='{{ "ProxyHistory" | translate}}'>
        <thead>
          <tr>
            <th scope="col" nzWidth="80px">{{ "ProxyFunction" | translate }}</th>
            <th scope="col" nzWidth="60px">{{ "EmployeeID" | translate }}</th>
            <th scope="col" nzWidth="100px">{{ "EmployeeName" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "ProxyID" | translate }}</th>
            <th scope="col" nzWidth="100px">{{ "ProxyName" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "table.PONO" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "StartDate" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "EndDate" | translate }}</th>
            <th scope="col" nzWidth="100px">{{ "Remark" | translate }}</th>
            <th scope="col" nzWidth="50px" [nzRight]="true">{{ "act" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data; let i = index">
            <td >{{data.function}}</td>
            <td >{{data.employeeID}}</td>
            <td >{{data.employeeName}}</td>
            <td >{{data.proxyID}}</td>
            <td >{{data.proxyName}}</td>
            <td >{{data.pono}}</td>
            <td >{{data.startDate}}</td>
            <td >{{data.endDate}}</td>
            <td >{{data.remark}}</td>
            <td style="align-content: center;" [nzRight]="true" *ngIf="!data.status && data.endDate>=dateNow"><span nz-icon nzType="edit" nzTheme="outline" (click)="onEdit(data)" ></span></td>
            <td *ngIf="data.status">Canceled</td>
            <td *ngIf="!data.status && dateNow>data.endDate"></td>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float: right" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]="pageSize"
        (nzPageSizeChange)="nzPageSizeChange($event)"  (nzPageIndexChange)="nzPageIndexChange($event)">
      </nz-pagination>
      <ng-template #renderItemTemplate let-type let-page="page">
         
        <a *ngIf="type === 'page'">{{ page }}</a>
        <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
        <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
      </ng-template>
    </div>

  <app-add-edit-proxy *ngIf="isAdd" [isAdd]="true" (close)="closeAdd()" (save)='saveAdd($event)'></app-add-edit-proxy>

  <app-add-edit-proxy *ngIf="isEdit" [isEdit]="true" [editData]="editData" (close)="closeAdd()" (save)="saveEdit($event)" (Cancel)="GetCancelFlag($event)" ></app-add-edit-proxy>
  </div>
</nz-spin>
</nz-card>



